import ServiceStyle from "../servicesCard/servicesCard.module.css";

export default function ServiceCard({ title, customColor, text, image }) {
  return (
    <div className={ServiceStyle.container}>
      <div className={ServiceStyle.text}>
        <h4 style={{ color: customColor }}>{title}</h4>
        <h6 style={{ fontSize: "1rem", lineHeight: "1.4" }}>{text}</h6>
      </div>
      <div className={ServiceStyle.image}>{image}</div>
    </div>
  );
}
